// @flow
import { getBasePathServer, RESOURCE_PATH } from "../../constants";

/**
 * Creates an url to a resource in the Be Informed repository
 * Only possible when serving using the UI Servlet of Be Informed
 */
export const getRepositoryResourceUrl = (
  resourceUrl: string,
  contextPath: string = getBasePathServer(),
  origin: string = "",
): string => {
  if (resourceUrl.startsWith(origin + contextPath)) {
    return resourceUrl;
  }

  if (resourceUrl.startsWith(RESOURCE_PATH)) {
    return `${origin}${contextPath}${resourceUrl}`;
  }

  return `${origin}${contextPath}${RESOURCE_PATH}${resourceUrl}`;
};
